import PurchaseList from "./views/purchaseOrders/poList/PoList";
import PurchaseDetails from "./views/purchaseOrders/poDetails/PoDetails";
import PurchaseOrderReport from "./views/purchaseOrders/poReport/PoReport";
import ClaimList from "./views/claims/claimList/ClaimList";
import ClaimDetails from "./views/claims/claimDetails/ClaimDetails";
import ClaimReport from "./views/claims/claimReport/ClaimReport";

const routes = [
  {
    path: "/PurchaseOrders",
    exact: true,
    name: "PurchaseOrders",
    component: PurchaseList
  },
  {
    path: "/PurchaseOrderDetails",
    exact: true,
    name: "PurchaseDetails",
    component: PurchaseDetails
  },
  {
    path: "/PurchaseOrderReport",
    exact: true,
    name: "PurchaseOrderReport",
    component: PurchaseOrderReport
  },
  {
    path: "/Claims",
    exact: true,
    name: "Claims",
    component: ClaimList
  },
  {
    path: "/ClaimDetails",
    exact: true,
    name: "ClaimDetails",
    component: ClaimDetails
  },
  {
    path: "/ClaimReport",
    exact: true,
    name: "ClaimReport",
    component: ClaimReport
  }
];

export default routes;
